var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "estates-search-filters" },
        [
          _vm.$root.is_mobile
            ? _c("mobile-filters", {
                attrs: {
                  config: _vm.config,
                  config_map: _vm.config_map,
                  districts: _vm.districts_list_event,
                  filters: _vm.filters,
                  "filter-values": _vm.filter_values,
                  geo_data: _vm.geo_data,
                  lang: _vm.lang,
                  placeholder: _vm.placeholder,
                  saveSearchDisable: _vm.saveSearchDisable,
                  searchData: _vm.searchData,
                  sector: _vm.filters.sector,
                  section: _vm.section
                },
                on: {
                  "update-geo": _vm.updateGeo,
                  "filters-updated": _vm.updateSearch
                }
              })
            : _c("desktop-filters", {
                attrs: {
                  count: _vm.count,
                  config: _vm.config,
                  config_map: _vm.config_map,
                  defaultValues: _vm.default_values,
                  districts: _vm.districts_list_event,
                  fallback: _vm.fallback,
                  filters: _vm.filters,
                  "filter-values": _vm.filter_values,
                  geo_data: _vm.geo_data,
                  lang: _vm.lang,
                  placeholder: _vm.placeholder,
                  saveSearchDisable: _vm.saveSearchDisable,
                  searchData: _vm.searchData,
                  sector: _vm.filters.sector,
                  section: _vm.section
                },
                on: {
                  "update-geo": _vm.updateGeo,
                  "filters-updated": _vm.updateSearch
                }
              })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }